import { yup } from '@guiker/yup-util'

export const readAllByScopeQuerySchema = yup.object({
  locale: yup.string().nullable(),
  scopeTypes: yup.array(yup.string()).nullable().default([]),
})

export type ReadAllByScopeQueryParams = yup.InferType<typeof readAllByScopeQuerySchema>
